import { shellStringResources } from '../../Resources/ShellStringResources';
import { IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { Trigger } from './trigger';


@Metamodel.model({
    name: shellStringResources.Trigger_Dependency
})
export class TriggerDependency {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        type: Trigger.MODEL,
        reference: true,
        constraint: {
            required: true
        }
    })
    public trigger: Trigger;

    @Metamodel.attribute({
        constraint: {
            required: false
        }
    })
    public name: string;

    @Metamodel.attribute({
        constraint: {
            required: false
        }
    })
    public offset: string;

    @Metamodel.attribute({
        constraint: {
            required: false
        }
    })
    public windowSize: string;

    constructor(trigger: Trigger, offset?: string, windowSize?: string) {
        this.trigger = trigger;
        this.name = trigger ? trigger.name : '';
        this.offset = offset || undefined;
        this.windowSize = windowSize || undefined;
    }
}
